/*
 *
 * ApmConfigurationModal
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 14-Jan-2025
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  successTitle: <PortalMessage id='t.app.project.popup.default.title.success' defaultMessage='Done!' />,
  successDescription: (
    <PortalMessage
      id='t.app.settings.apmConfiguration.popUp.result.success.description'
      defaultMessage='The configuration of the APM was successful.'
    />
  ),
  failureTitle: <PortalMessage id='t.app.project.popup.default.error.title' defaultMessage='Oops!' />,
  failureDescription: (
    <PortalMessage
      id='t.app.settings.apmConfiguration.popUp.result.error.subtitle'
      defaultMessage='An error has occurred.'
    />
  ),
  pProFieldsContractIdLabel: (
    <PortalMessage id='t.app.settings.apmConfiguration.popUp.pPro.contractId' defaultMessage='PPRO Contract ID' />
  ),
  heylightFieldsMerchantKeyLabel: (
    <PortalMessage id='t.app.settings.apmConfiguration.popUp.heylight.merchantKey' defaultMessage='Merchant Key' />
  ),
  accept: <PortalMessage id='t.app.settings.apmConfiguration.popUp.termAndCondition.accept' defaultMessage='Accept' />,
  link: (
    <PortalMessage
      id='t.app.settings.apmConfiguration.popUp.termAndCondition.link'
      defaultMessage='Terms and Conditions'
    />
  ),
  acceptPpro: (
    <PortalMessage
      id='t.app.settings.apmConfiguration.popUp.termAndCondition'
      defaultMessage='Accept Terms and Conditions'
    />
  ),
  termsAndConditionsText: (
    <PortalMessage
      id='t.app.settings.apmConfiguration.popUp.termsAndConditions.text'
      defaultMessage='I, THE UNDERSIGNED LEGAL REPRESENTATIVE OF THE COMPANY (HEREINAFTER THE “MERCHANT”), ACKNOWLEDGE that the service relating to alternative payment instruments provided by third parties is provided exclusively at the technical level. Liability, administrative obligations, and legal matters are governed by the contracts between the Merchant and the relevant payment service providers.'
    />
  ),
  confirm: <PortalMessage id='t.app.settings.apmConfiguration.popUp.cta.confirm' defaultMessage='Confirm' />,
  paypalId: <PortalMessage id='t.app.settings.apmConfiguration.popUp.paypal.id' defaultMessage='Paypal ID' />,
  paypalEmail: <PortalMessage id='t.app.settings.apmConfiguration.popUp.paypal.email' defaultMessage='Paypal Email' />,
  satispayDirectFieldsTokenLabel: <PortalMessage id='t.app.settings.apmConfiguration.popUp.satispay.token' defaultMessage='Token' />,
  merchantReferenceId: <PortalMessage id='t.app.settings.apmConfiguration.popUp.alipayPlus.merchantReferenceId' defaultMessage='Merchant Reference ID' />
}

export const messages = {
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  apmSwitchAriaLabel: {
    id: 't.app.accessibility.settings.apmConfiguration.enable.ariaLabel',
    defaultMessage: 'Close'
  },
  title: {
    id: 't.app.apmConfigurationModal.title',
    defaultMessage: 'Manage the service'
  },
  alt: {
    id: 't.app.apmConfigurationModal.alt',
    defaultMessage: 'Manage the service'
  },
  paypalId: { id: 't.app.settings.apmConfiguration.popUp.paypal.id', defaultMessage: 'Paypal ID' },
  paypalEmail: { id: 't.app.settings.apmConfiguration.popUp.paypal.email', defaultMessage: 'Paypal Email' },
  pProFieldsAcceptError: {
    id: 't.app.settings.apmConfiguration.popUp.pPro.accept.isRequiredError',
    defaultMessage: 'Field is required'
  },
  pProFieldsContractIdError: {
    id: 't.app.settings.apmConfiguration.popUp.pPro.contractId.isRequiredError',
    defaultMessage: 'Field is required'
  },
  heylightFieldsMerchantKeyLengthError: {
    id: 't.app.settings.apmConfiguration.popUp.heylight.merchantKey.lengthError',
    defaultMessage: 'Invalid Merchant Key'
  },
  heylightFieldsMerchantKeyRequiredError: {
    id: 't.app.settings.apmConfiguration.popUp.heylight.merchantKey.isRequiredError',
    defaultMessage: 'Field is required'
  },
  showMore: { id: 't.app.settings.apmConfiguration.popUp.showMore', defaultMessage: 'Show more' },
  showLess: { id: 't.app.settings.apmConfiguration.popUp.showLess', defaultMessage: 'Show less' },
  accept: { 
    id: 't.app.settings.apmConfiguration.popUp.termAndCondition.accept', 
    defaultMessage: 'Accept' 
  },
  link: { 
    id: 't.app.settings.apmConfiguration.popUp.termAndCondition.link', 
    defaultMessage: 'Terms and Conditions' 
  },
  acceptPpro: { 
    id: 't.app.settings.apmConfiguration.popUp.termAndCondition', 
    defaultMessage: 'Accept Terms and Conditions' 
  },
  pProFieldsContractIdLabel: {
    id: 't.app.settings.apmConfiguration.popUp.pPro.contractId',
    defaultMessage: 'PPRO Contract ID'
  },
  pProFieldsContractIdAlert: {
    id: 't.app.settings.apmConfiguration.popUp.pPro.contractId.alert',
    defaultMessage: 'The selected payment method may return non-final results (status: pending). Be sure to handle these cases correctly in your payment workflows; for more details, see the developer portal.'
  },
  heylightFieldsMerchantKeyLabel: {
    id: 't.app.settings.apmConfiguration.popUp.heylight.merchantKey',
    defaultMessage: 'Merchant Key'
  },
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  },
  isRequired: {
    id: 't.app.project.error.isRequired',
    defaultMessage: 'This field is required'
  }
}

export default formattedMessage
